import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { ROLES, PRIVILEGES } from '@projects/constants/rolesPrivileges'

export const useAuthStore = defineStore('projects:auth', () => {
  // state
  const user = ref(window.siteVars?.user || null)
  const userActions = ref(window.pageVars?.userActions?.userActions || [])
  const userActionsScope = ref(window.pageVars?.userActions?.scope || '')

  // getters
  const privileges = computed(() => user.value?.privileges || [])
  const userRoles = computed(() => user.value?.roles || [])
  const canManageProjectAccess = computed(() => privileges.value.includes(PRIVILEGES.MANAGE_PROJECT_ACCESS))
  const canManageProjectTransactions = computed(() => privileges.value.includes(PRIVILEGES.MANAGE_PROJECT_TRANSACTIONS))
  const canSeeUpgradeCostEstimateLink = computed(() => privileges.value.includes(PRIVILEGES.MANAGE_UPGRADE_COST_ESTIMATE))
  const isGridUnityAdmin = computed(() => userRoles.value.includes(ROLES.GRID_UNITY_ADMIN))

  // setters
  function setUserActions(data) {
    userActions.value = data?.userActions || []
    userActionsScope.value = data?.scope || ''
  }

  return {
    // state
    user,
    userActions,
    userActionsScope,

    // getters
    canManageProjectAccess,
    canManageProjectTransactions,
    canSeeUpgradeCostEstimateLink,
    isGridUnityAdmin,
    privileges,
    userRoles,

    // setters
    setUserActions,
  }
})
